import * as React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useTranslation } from "react-i18next";

interface Props {
    onCreate: () => void;
    onEdit: () => void;
    onDelete: () => void;
    disableCreate: boolean;
    disableModify: boolean;
}

const ScheduleWeekActionsMenu = ({ onCreate, onEdit, onDelete, disableCreate, disableModify }: Props) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const callAndClose = (callback: () => void) => {
        handleClose();
        callback();
    };

    return (
        <>
            <Button color="inherit" type="button" onClick={handleOpen}>
                {t("schedule_week_actions")}
            </Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem disabled={disableCreate} onClick={() => callAndClose(onCreate)}>
                    {t("create_week")}
                </MenuItem>
                <MenuItem disabled={disableModify} onClick={() => callAndClose(onEdit)}>
                    {t("update_week_schedule")}
                </MenuItem>
                <MenuItem disabled={disableModify} onClick={() => callAndClose(onDelete)}>
                    {t("delete_week")}
                </MenuItem>
            </Menu>
        </>
    );
};

export default ScheduleWeekActionsMenu;
